import { combineReducers } from 'redux';
import tracking from './tracking';
import settings from './settings';
import languageReducer from './languageReducer';

export default combineReducers({
  tracking,
  settings,
  language: languageReducer,
});
